import type { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';

/**
 * Helper que lee una CSS variable de :root.
 * Asi los tokens de Ant Design se sincronizan con el archivo theme.css.
 */
function readCssVar(name: string): string {
  if (typeof window === 'undefined') return '';
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

/**
 * Construye el ThemeConfig de Ant Design leyendo las CSS variables actuales.
 * Se llama cada vez que cambia el modo (claro/oscuro) para que Ant Design
 * use los nuevos colores.
 */
export function buildAntdTheme(mode: 'light' | 'dark'): ThemeConfig {
  return {
    algorithm: mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: readCssVar('--color-primary') || '#1677ff',
      colorSuccess: readCssVar('--color-success') || '#52c41a',
      colorWarning: readCssVar('--color-warning') || '#faad14',
      colorError: readCssVar('--color-error') || '#ff4d4f',
      colorInfo: readCssVar('--color-info') || '#1677ff',

      colorBgBase: readCssVar('--color-bg-base') || (mode === 'dark' ? '#141414' : '#ffffff'),
      colorBgLayout: readCssVar('--color-bg-layout') || (mode === 'dark' ? '#000000' : '#f5f5f5'),

      colorTextBase: mode === 'dark' ? '#ffffff' : '#000000',

      borderRadius: 6,
      borderRadiusLG: 8,
      borderRadiusSM: 4,

      fontFamily: readCssVar('--font-family') || undefined,
      fontSize: 14,

      controlHeight: 36,
    },
    components: {
      Layout: {
        siderBg: readCssVar('--color-bg-sider') || '#001529',
        headerBg: readCssVar('--color-bg-header') || '#ffffff',
        headerHeight: 64,
        headerPadding: '0 24px',
      },
      Menu: {
        darkItemBg: readCssVar('--color-bg-sider') || '#001529',
      },
      Card: {
        boxShadowTertiary: readCssVar('--shadow-sm'),
      },
    },
  };
}
